export class UserData
{
    public Username: string;
    public Password: string;
    public PasswordHistory1: string;
    public PasswordHistory2: string;
    public NeedsPasswordChange: boolean = false;

    constructor(
        Username: string,
        Password: string,
        PasswordHistory1: string,
        PasswordHistory2: string,
        NeedsPasswordChange: boolean
    )
    {
        this.Username = Username;
        this.Password = Password;
        this.PasswordHistory1 = PasswordHistory1;
        this.PasswordHistory2 = PasswordHistory2;
        this.NeedsPasswordChange = NeedsPasswordChange;
    }
}